import {resolveRoute} from '../helpers/ajax'
import React, {useMemo} from 'react'
import {BookingsDataTable} from './BookingsDataTable'


type CustomerBookingsTableProps = {
    customerId: StringNum
    showPaymentsColumn: boolean
    showDriverColumn: boolean

}

export function CustomerBookingsTable({customerId, showPaymentsColumn, showDriverColumn}: CustomerBookingsTableProps) {
    const props = useMemo(() => ({
        ajaxSource: resolveRoute('api.dashboardBookings'),
        serverData: {customerId, includeYear: true},
        showPaymentsColumn,
        showDriverColumn,
        storageKey: 'customer',
        showPastColumn: true,
    }), [customerId, showDriverColumn, showPaymentsColumn])

    return <BookingsDataTable {...props} />
}
